import { useState } from "react";
import { ListItem } from "../../../__shared__/ListItem/ListItem";
import styles from "./Badges.module.scss";
import ArrowRight from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/ArrowRight24PxOutlined";
import cx from "classnames";
import { Drawer } from "./Drawer/Drawer";
import { CleanBeautyLabels } from "../../../../hooks/useCleanBeauty/cleanBeautySchema";
import badgesTexts from "./badgesText.json";

type BadgesProps = {
  labels: CleanBeautyLabels[];
};

const classNames = cx(styles.list, styles.badge);

function transformIngredientText(badges: string) {
  return badges
    .replace(/_/, " ")
    .split(" ")
    .map(
      (word) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase(),
    )
    .join(" ");
}

export const Badges = ({ labels: badges }: BadgesProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [header, setHeader] = useState<string>("");
  const [description, setDescription] = useState<string[]>([]);

  const handleCloseDrawer = () => {
    setIsOpen(false);
  };
  return (
    <div className={styles.badges}>
      <Drawer
        isOpen={isOpen}
        handleClose={handleCloseDrawer}
        badgeHeader={header}
        description={description}
      ></Drawer>
      {badges.map((badge, index) => (
        <ListItem
          key={index}
          trailingIcon={<ArrowRight data-testid={"badgelabels-arrow"} />}
          label={transformIngredientText(badge)}
          onClick={() => {
            setHeader(transformIngredientText(badge));
            setDescription(badgesTexts[badge]);
            setIsOpen(true);
          }}
          className={classNames}
        />
      ))}
    </div>
  );
};
